module.exports = __webpack_public_path__ + "static/img/ic_community_b.dbf5f9c5.png";